"use strict";
exports.__esModule = true;
exports.POWER_UPS_DATA = void 0;
exports.POWER_UPS_DATA = [
    {
        name: 'File Manager',
        description: "Easily access and manage all of a board's file attachments in one convenient place.",
        image: '/assets/power-ups/file-manager-icon-web.png',
        idPlugin: '60bd32bfc2fcaf094b4a9d49',
        url: 'https://trello.com/power-ups/60bd32bfc2fcaf094b4a9d49',
        enableUrl: 'https://trello.com/power-ups/60bd32bfc2fcaf094b4a9d49/enable'
    },
    {
        name: 'External Share',
        description: 'Share with anyone outside of Trello without having to add them to your board or team!',
        image: '/assets/power-ups/external-share-icon-web.png',
        idPlugin: '60d93bb780ee244d5d2b1edd',
        url: 'https://trello.com/power-ups/60d93bb780ee244d5d2b1edd',
        enableUrl: 'https://trello.com/power-ups/60d93bb780ee244d5d2b1edd/enable'
    },
    {
        name: 'Board Chat',
        description: "Add a chat to any Trello board, a great place for general chat that isn't specific to a card.",
        image: '/assets/power-ups/board-chat-icon-web.png',
        idPlugin: '60e30ce36985a680f69727ea',
        url: 'https://trello.com/power-ups/60e30ce36985a680f69727ea',
        enableUrl: 'https://trello.com/power-ups/60e30ce36985a680f69727ea/enable'
    },
    {
        name: 'Card Approvals',
        description: 'For workflows that need cards to be approved at different stages.',
        image: '/assets/power-ups/approvals-icon-web.png',
        idPlugin: '60e8b069fee48a45a1fe27cc',
        url: 'https://trello.com/power-ups/60e8b069fee48a45a1fe27cc',
        enableUrl: 'https://trello.com/power-ups/60e8b069fee48a45a1fe27cc/enable'
    },
    {
        name: 'Board and Card Keys',
        description: 'Assign unique keys and short-links to a board and its cards.',
        image: '/assets/power-ups/board-key-icon-web.png',
        idPlugin: '60e66ee45654886914027695',
        url: 'https://trello.com/power-ups/60e66ee45654886914027695',
        enableUrl: 'https://trello.com/power-ups/60e66ee45654886914027695/enable'
    },
    {
        name: 'Analytics',
        description: 'Track views across boards & cards, integrate with Google analytics.',
        image: '/assets/power-ups/analytics-icon-web.png',
        idPlugin: '613269624bccb32439780227',
        url: 'https://trello.com/power-ups/613269624bccb32439780227',
        enableUrl: 'https://trello.com/power-ups/613269624bccb32439780227/enable'
    },
    {
        name: 'Office File Viewer',
        description: 'Preview Microsoft Word, Excel, and PowerPoint attachment files directly in Trello.',
        image: '/assets/power-ups/office-file-viewer-web-icon.png',
        idPlugin: '61bd1b71e0984756b13f7696',
        url: 'https://trello.com/power-ups/61bd1b71e0984756b13f7696',
        enableUrl: 'https://trello.com/power-ups/61bd1b71e0984756b13f7696/enable'
    },
    {
        name: 'Archive Manager',
        description: 'View and manage your archived lists and cards into a rich board view!',
        image: '/assets/power-ups/archive-manager-web-icon.png',
        idPlugin: '61bfae4618f27c85f037a518',
        url: 'https://trello.com/power-ups/61bfae4618f27c85f037a518',
        enableUrl: 'https://trello.com/power-ups/61bfae4618f27c85f037a518/enable'
    },
    {
        name: 'Durations',
        description: 'Clearly show how long cards have been in their current list, current board, and the time left until they are due!',
        image: '/images/durations-web-icon.png',
        idPlugin: '61d0a97844f61a122de45e58',
        url: 'https://trello.com/power-ups/61d0a97844f61a122de45e58/durations',
        enableUrl: 'https://trello.com/power-ups/61d0a97844f61a122de45e58/enable'
    },
    {
        name: 'Gallery View',
        description: 'Display your image attachments in an awesome Pinterest style gallery!',
        image: '/images/gallery-view-web-icon.png',
        idPlugin: '61e4b4ca8cc16244f5ae9309',
        url: 'https://trello.com/power-ups/61e4b4ca8cc16244f5ae9309/gallery-view',
        enableUrl: 'https://trello.com/power-ups/61e4b4ca8cc16244f5ae9309/enable'
    },
    {
        name: 'Table View',
        description: 'See your Trello cards in a powerful, and manageable table format.',
        image: '/images/tableview-icon-web.png',
        idPlugin: '61f4c0464f8522341a806b89',
        url: 'https://trello.com/power-ups/61f4c0464f8522341a806b89/table-view',
        enableUrl: 'https://trello.com/power-ups/61f4c0464f8522341a806b89/enable'
    },
    {
        name: 'Polls',
        description: 'Create polls on your Trello cards for your team to vote on anything! 🗳',
        image: '/images/polls-icon-web.png',
        idPlugin: '62ac96fd583bad72dcb656c5',
        url: 'https://trello.com/power-ups/62ac96fd583bad72dcb656c5/polls',
        enableUrl: 'https://trello.com/power-ups/62ac96fd583bad72dcb656c5/enable'
    },
    {
        name: 'Advanced Card Covers',
        description: 'Card cover generator - colors, gradients, patterns, images, and text!',
        image: '/images/advanced-card-covers-icon-web.png',
        idPlugin: '63335b84732512002ab83405',
        url: 'https://trello.com/power-ups/63335b84732512002ab83405/advanced-card-covers',
        enableUrl: 'https://trello.com/power-ups/63335b84732512002ab83405/enable'
    },
    {
        name: 'Show fields on card front',
        description: 'Show attachments, show checklists, show location, show members, and show description on the front of the card!',
        image: '/images/show-on-card-front-icon-web.png',
        idPlugin: '634f6e698f760b05b67fec3d',
        url: 'https://trello.com/power-ups/634f6e698f760b05b67fec3d/show-fields-on-card-front',
        enableUrl: 'https://trello.com/power-ups/634f6e698f760b05b67fec3d/enable'
    },
    {
        name: 'Bookmarks',
        description: 'Add bookmarks and folders to organize useful links on your board',
        image: '/images/bookmarks-icon-web.png',
        idPlugin: '636b18ce7b6e45024878afe9',
        url: 'https://trello.com/power-ups/636b18ce7b6e45024878afe9/bookmarks-for-trello',
        enableUrl: 'https://trello.com/power-ups/636b18ce7b6e45024878afe9/enable'
    },
    {
        name: 'Forms',
        description: 'Create custom forms and collect responses right on your Trello board!',
        image: '/images/forms-icon-web.png',
        idPlugin: '6381377e7e70e001b13e8e9e',
        url: 'https://trello.com/power-ups/6381377e7e70e001b13e8e9e/forms-for-trello',
        enableUrl: 'https://trello.com/power-ups/6381377e7e70e001b13e8e9e/enable'
    },
    {
        name: 'Saved Filters',
        description: 'Save your filters for quick access to your favorite views of your board!',
        image: '/images/filters-icon-web.png',
        idPlugin: '63a5e1f4c0ee7f00e19bf60c',
        url: 'https://trello.com/power-ups/63a5e1f4c0ee7f00e19bf60c/forms-for-trello',
        enableUrl: 'https://trello.com/power-ups/63a5e1f4c0ee7f00e19bf60c/enable'
    },
    {
        name: 'Conditional List Colors',
        description: 'Change list colors based on certain dynamic conditions',
        image: '/images/conditional-list-colors-icon-web.png',
        idPlugin: '65dcea8fc8864ee96cb4c5cc',
        url: 'https://trello.com/power-ups/65dcea8fc8864ee96cb4c5cc/conditional-list-colors',
        enableUrl: 'https://trello.com/power-ups/65dcea8fc8864ee96cb4c5cc/enable'
    },
];
//# sourceMappingURL=powerUpsData.js.map